import React, { memo } from "react";
import { Link } from "react-router-dom";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const Table = memo(function Table(props) {
    function getValueFromPath(obj, path) {
        if (!path) return undefined;
        return path.split(".").reduce((acc, key) => acc?.[key], obj);
    }

    return (
        <div className={`flex flex-col`}>
            <div
                className={`-my-2 ${!props.nonScrolleable && "overflow-x-auto"} sm:-mx-6 lg:-mx-8`}
            >
                <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div
                        className={`shadow ${!props.sticky && "overflow-hidden"} border-b border-gray-200 sm:rounded-lg`}
                    >
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead
                                className={`bg-gray-50 ${props.sticky && "sticky top-0 z-30 shadow-sm"}`}
                            >
                                <tr>
                                    {props.columns.map((column, colIndx) => (
                                        <>
                                            <th
                                                scope="col"
                                                className={`${props.sticky && colIndx === 0 && "sticky left-0 bg-gray-50"} px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider`}
                                            >
                                                {column.displayText}
                                            </th>
                                        </>
                                    ))}
                                    {props.actiontext && (
                                        <th
                                            scope="col"
                                            className="relative px-6 py-3"
                                        >
                                            <span className="sr-only">
                                                Edit
                                            </span>
                                        </th>
                                    )}
                                    {props.delete && (
                                        <th
                                            scope="col"
                                            className="relative px-6 py-3"
                                        >
                                            <span className="sr-only">
                                                Edit
                                            </span>
                                        </th>
                                    )}
                                    {props.openModal && (
                                        <th
                                            scope="col"
                                            className="relative px-6 py-3"
                                        >
                                            <span className="sr-only">
                                                Edit
                                            </span>
                                        </th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {props.rows.map((row, rowIdx) => (
                                    <tr
                                        key={rowIdx}
                                        className={
                                            rowIdx % 2 === 0
                                                ? "bg-white"
                                                : "bg-gray-50"
                                        }
                                        onClick={() =>
                                            props.navigate &&
                                            props.navigate(
                                                `/${props.path}/${row.id}`,
                                            )
                                        }
                                        style={{
                                            cursor: props.navigate
                                                ? "pointer"
                                                : "default",
                                        }}
                                    >
                                        {row.isTitle && (
                                            <td
                                                className={`${props.sticky && `${rowIdx % 2 === 0 ? "bg-white" : "bg-gray-50"} sticky left-0 z-20`} px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-800`}
                                            >
                                                {row.name}
                                            </td>
                                        )}
                                        {props.columns.map((column, colIdx) =>
                                            column.clickable ? (
                                                <td
                                                    className={`${props.sticky && colIdx === 0 && `${rowIdx % 2 === 0 ? "bg-white" : "bg-gray-50"} sticky left-0 z-20`} ${column.truncate ? "truncate max-w-xs" : ""} px-6 py-4 whitespace-nowrap text-left text-sm font-medium`}
                                                >
                                                    <Link
                                                        to={`/${props.module}/${row.id}`}
                                                        className="text-primary hover:text-primary capitalize"
                                                    >
                                                        {getValueFromPath(
                                                            row,
                                                            column.name,
                                                        )}
                                                    </Link>
                                                </td>
                                            ) : (
                                                (colIdx !== 0 ||
                                                    !row.isTitle) && (
                                                    <td
                                                        className={`${props.sticky && colIdx === 0 && `${rowIdx % 2 === 0 ? "bg-white" : "bg-gray-50"} sticky left-0 z-20`} ${column.truncate ? "truncate max-w-xs" : ""} px-6 py-4 whitespace-nowrap text-gray-500 text-sm capitalize ${!!props.firstColumnBold && colIdx === 0 && "font-normal"}`}
                                                    >
                                                        {!row.isTitle &&
                                                            (getValueFromPath(
                                                                row,
                                                                column.name,
                                                            ) ||
                                                            getValueFromPath(
                                                                row,
                                                                column.name,
                                                            ) === 0
                                                                ? getValueFromPath(
                                                                      row,
                                                                      column.name,
                                                                  )
                                                                : "--")}
                                                    </td>
                                                )
                                            ),
                                        )}
                                        {props.actiontext && (
                                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                {props.document ? (
                                                    <a
                                                        target="_BLANK"
                                                        rel="noopener noreferrer"
                                                        href={row.document}
                                                        className="text-primary hover:text-primary"
                                                    >
                                                        {props.actiontext}
                                                    </a>
                                                ) : (
                                                    <Link
                                                        to={`/${props.module}/${row.id}`}
                                                        className="text-primary hover:text-primary"
                                                    >
                                                        {props.actiontext}
                                                    </Link>
                                                )}
                                            </td>
                                        )}
                                        {props.delete && (
                                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                <button
                                                    onClick={() => (
                                                        props.setSelectedDocument(
                                                            row,
                                                        ),
                                                        props.setOpenDelete(
                                                            true,
                                                        )
                                                    )}
                                                    className="text-red hover:text-red"
                                                >
                                                    Eliminar
                                                </button>
                                            </td>
                                        )}
                                        {props.openModal && (
                                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        props.openModal(row);
                                                    }}
                                                    className="text-primary hover:text-primary"
                                                >
                                                    {props.openModalText ||
                                                        "Editar"}
                                                </button>
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                            {props.pagination ? (
                                <tfoot>
                                    <tr>
                                        <td
                                            colSpan={
                                                props.columns.length +
                                                (props.actiontext ? 1 : 0) +
                                                (props.delete ? 1 : 0) +
                                                (props.openModal ? 1 : 0)
                                            }
                                        >
                                            <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
                                                <div className="flex-1 flex justify-between sm:hidden">
                                                    <button
                                                        onClick={
                                                            props.pagination
                                                                .onPrevious
                                                        }
                                                        disabled={
                                                            props.pagination
                                                                .currentPage ===
                                                            1
                                                        }
                                                        className={`relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${
                                                            props.pagination
                                                                .currentPage ===
                                                            1
                                                                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                                : "text-gray-700 bg-white hover:bg-gray-50"
                                                        }`}
                                                    >
                                                        Anterior
                                                    </button>
                                                    <button
                                                        onClick={
                                                            props.pagination
                                                                .onNext
                                                        }
                                                        disabled={
                                                            props.pagination
                                                                .currentPage ===
                                                            props.pagination
                                                                .totalPages
                                                        }
                                                        className={`ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md ${
                                                            props.pagination
                                                                .currentPage ===
                                                            props.pagination
                                                                .totalPages
                                                                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                                : "text-gray-700 bg-white hover:bg-gray-50"
                                                        }`}
                                                    >
                                                        Siguiente
                                                    </button>
                                                </div>
                                                <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                                                    <div>
                                                        <p className="text-sm text-gray-700">
                                                            Mostrando{" "}
                                                            <span className="font-medium">
                                                                {
                                                                    props
                                                                        .pagination
                                                                        .start
                                                                }
                                                            </span>{" "}
                                                            a{" "}
                                                            <span className="font-medium">
                                                                {
                                                                    props
                                                                        .pagination
                                                                        .end
                                                                }
                                                            </span>{" "}
                                                            de{" "}
                                                            <span className="font-medium">
                                                                {
                                                                    props
                                                                        .pagination
                                                                        .total
                                                                }
                                                            </span>{" "}
                                                            resultados
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <nav
                                                            className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                                                            aria-label="Pagination"
                                                        >
                                                            <button
                                                                onClick={
                                                                    props
                                                                        .pagination
                                                                        .onPrevious
                                                                }
                                                                disabled={
                                                                    props
                                                                        .pagination
                                                                        .currentPage ===
                                                                    1
                                                                }
                                                                className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 text-sm font-medium ${
                                                                    props
                                                                        .pagination
                                                                        .currentPage ===
                                                                    1
                                                                        ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                                        : "bg-white text-gray-500 hover:bg-gray-50"
                                                                }`}
                                                            >
                                                                <span className="sr-only">
                                                                    Anterior
                                                                </span>
                                                                <ChevronLeftIcon
                                                                    className="h-5 w-5"
                                                                    aria-hidden="true"
                                                                />
                                                            </button>
                                                            {props.pagination.pages?.map(
                                                                (pageNum) => {
                                                                    const isCurrent =
                                                                        pageNum ===
                                                                        props
                                                                            .pagination
                                                                            .currentPage;
                                                                    return (
                                                                        <button
                                                                            key={
                                                                                pageNum
                                                                            }
                                                                            type="button"
                                                                            onClick={() =>
                                                                                props.pagination.onPageChange(
                                                                                    pageNum,
                                                                                )
                                                                            }
                                                                            aria-current={
                                                                                isCurrent
                                                                                    ? "page"
                                                                                    : undefined
                                                                            }
                                                                            className={
                                                                                isCurrent
                                                                                    ? "z-10 bg-indigo-50 border-primary text-primary relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                                                                                    : "bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
                                                                            }
                                                                        >
                                                                            {
                                                                                pageNum
                                                                            }
                                                                        </button>
                                                                    );
                                                                },
                                                            )}
                                                            <button
                                                                onClick={
                                                                    props
                                                                        .pagination
                                                                        .onNext
                                                                }
                                                                disabled={
                                                                    props
                                                                        .pagination
                                                                        .currentPage ===
                                                                    props
                                                                        .pagination
                                                                        .totalPages
                                                                }
                                                                className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 text-sm font-medium ${
                                                                    props
                                                                        .pagination
                                                                        .currentPage ===
                                                                    props
                                                                        .pagination
                                                                        .totalPages
                                                                        ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                                        : "bg-white text-gray-500 hover:bg-gray-50"
                                                                }`}
                                                            >
                                                                <span className="sr-only">
                                                                    Siguiente
                                                                </span>
                                                                <ChevronRightIcon
                                                                    className="h-5 w-5"
                                                                    aria-hidden="true"
                                                                />
                                                            </button>
                                                        </nav>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>
                            ) : null}
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default Table;
